import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Locale } from '@qb/shared';
import { SUPPORTED_LOCALES, isRtl } from '@qb/shared';
import { setLocale } from '@/locales';

/**
 * Composable for reading and switching the app locale.
 * Wraps vue-i18n so callers don't need to know about the storage / dir side effects.
 */
export function useLocale() {
  const { locale } = useI18n();

  const current = computed<Locale>(() => locale.value as Locale);
  const direction = computed<'rtl' | 'ltr'>(() => (isRtl(current.value) ? 'rtl' : 'ltr'));
  const isRTL = computed(() => direction.value === 'rtl');

  function change(next: Locale): void {
    setLocale(next);
  }

  return {
    locale: current,
    direction,
    isRTL,
    supportedLocales: SUPPORTED_LOCALES,
    change,
  };
}
